import LoginLoader from './LoginLoader';
export default LoginLoader;
